import {memoize, kebabCase} from '@servicenow/ui-internal';

export default memoize(
	function toAttributeName(propName) {
		return kebabCase(propName);
	},
	{profileName: 'toAttributeName'}
);
